<template>
  <div class="bottom" id="contact-id">
    <div class="box_1">
      <div class="box_1_left">
        <div class="t_1">公司</div>
        <div class="t_2" @click="goto(1)">关于我们</div>
        <div class="t_3" @click="goto(2)">联系我们</div>
      </div>
      <div class="box_1_right">
        <div class="t_1">法律</div>
        <div class="t_2">
          <a
            class="t_22"
            target="_blank"
            href="https://docs.qq.com/doc/DYlZkWFVQUmV3Y0ZZ"
            >用户协议</a
          >
        </div>
        <div class="t_3">
          <a
            class="t_33"
            target="_blank"
            href="https://docs.qq.com/doc/DYlJXSEVHYUF4SElo"
            >隐私政策</a
          >
        </div>
      </div>
    </div>
    <div class="box_2">
      <div class="logo">
        <img src="../assets/images/Logo.png" />
      </div>
      <div style="margin-top: 10px">
        <div class="t_1">
          <img src="../assets/images/beian.png" style="width: 30px; height: 30px" />
          <a
            class="t11"
            target="_blank"
            href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002007645"
          >川公网安备51019002007645号</a
          >
          <a
            class="t3"
            target="_blank"
            href="https://beian.miit.gov.cn/#/Integrated/index"
          >
            <span v-if="isCn">蜀ICP备2021009784号-14</span>
            <span v-else>蜀ICP备2021009784号-16</span>
          </a
          >
        </div>
        <div class="t_2">成都精诚绿洲网络科技有限公司</div>
      </div>
    </div>
    <div class="box_2_contact">
      <div class="contact-title">联系/关注我们</div>
      <div class="t_1 d-flex">
       <div class="t11 pr-2">
          <div class="d-flex">
            <span class="icon-qq"></span>
            <span>官方QQ群: 431610902</span>
          </div>
          <div>
            <img class="contact-qrcode" src="../assets/images/ai-contact.jpg">
          </div>
       </div>
        <div class="t11">
          <div class="d-flex">
            <span class="icon-wx"></span>
            <span>ZZ游戏助手公众号</span>
          </div>
          <div>
            <img class="contact-qrcode" src="../assets/images/ai-common.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  components: {},

  data() {
    return {
      isCn: false,
      local: '',
      environment: ''
    };
  },
  mounted() {
    this.$store.state.offsetTop = document.getElementById('contact-id').offsetTop
    this.isCn = window.location.href.includes('cn')
    // this.local = window.location.hostname
    // 判断并区分不同的环境
  },
  methods: {
    goto(index) {
      if (index == 1) {
        this.$router.push("/aboutus");
      }
      if (index == 2) {
        this.$router.push("/contactus");
      }
      if (index == 3) {
        this.$router.push("/useragreement");
      }
    },
  },
};
</script>
<style scoped lang="less">
.bottom {
  // position: fixed;
  background: linear-gradient(to right, #140223, #121f45);
  width: 100%;
  // border: 1px solid red;
  margin-top: auto;
  height: 274px;
  display: flex;
  align-items: center;
  .box_1 {
    // margin-left: 527px;
    width: 227px;
    flex: 1;
    height: 126px;
    // border: 1px solid red;
    display: flex;
    justify-content: flex-end;
    .box_1_left {
      display: flex;
      flex-direction: column;
      .t_1 {
        font-size: 22px;
        color: #8e8e8e;
      }
      .t_2 {
        margin-top: 24px;
        font-size: 20px;
        color: #fff;
        cursor: pointer;
      }
      .t_2:hover {
        color: #5599ff;
      }
      .t_3 {
        margin-top: 16px;
        font-size: 20px;
        color: #fff;
      }
      .t_3:hover {
        color: #5599ff;
        cursor: pointer;
      }
    }
    .box_1_right {
      margin-left: 64px;
      display: flex;
      flex-direction: column;
      .t_1 {
        font-size: 22px;
        color: #8e8e8e;
      }
      .t_2 {
        margin-top: 24px;
        .t_22 {
          margin-top: 24px;
          font-size: 20px;
          color: #fff;
          cursor: pointer;
        }
        .t_22:hover {
          color: #5599ff;
        }
      }

      .t_3 {
        margin-top: 16px;
        .t_33 {
          margin-top: 24px;
          font-size: 20px;
          color: #fff;
          cursor: pointer;
        }
        .t_33:hover {
          color: #5599ff;
        }
      }
    }
  }
}
.box_2 {
  margin-left: 104px;
  margin-right: 60px;
  display: flex;
  flex-direction: column;
  .logo {
    width: 108px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .t_1 {
    display: flex;
    align-items: center;
    .gongan {
      width: 20px;
      height: 20px;
      background: url(~@/assets/images/gongan.png);
      background-size: cover;
    }
    .t1 {
      color: #8e8e8e;
      font-size: 22px;
      margin-left: 4px;
    }
    .t11 {
      color: #8e8e8e;
      font-size: 22px;
      margin-left: 4px;
      cursor: pointer;
    }
    .t11:hover {
      color: #5599ff;
    }
    .t2 {
      margin-left: 4px;
      color: #8e8e8e;
      font-size: 22px;
    }
    .t3 {
      color: #8e8e8e;
      font-size: 22px;
      margin-left: 20px;
    }
    .t3:hover {
      color: #5599ff;
    }
  }
  .t_2 {
    margin-top: 14px;
    color: #8e8e8e;
    font-size: 22px;
  }
}
.contact-title {
  font-size: 22px;
  color: #8e8e8e;
}
.box_2_contact{
  margin-right: 240px;
  margin-top: 8px;
  .t11 {
    color: #E8E8E8;
    font-size: 22px;
  }
  .d-flex {
    display: flex;
    align-items: center;
    >div{
      margin-top: 16px;
      margin-right: 10px;
    }
    .contact-qrcode {
      width: 88px;
      height: 87.97px;
      margin-top: 16px;
    }
  }
}
.pr-2 {
  padding-right: 40px;
}
.icon-qq {
  background-image: url("@/assets/images/qq.png");
  width: 24px;
  height: 24px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-right: 4px;
}
.icon-wx {
  background-image: url("@/assets/images/wx.png");
  width: 22px;
  height: 24px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-right: 4px;
}
</style>
